import * as React from 'react';
import { useDayMonthYear } from '@zen/common-react-hooks';
import { textUtils } from '@zen/common-utils';
import { NamingUtils } from '@zen/common-app-parts';

const { addPrecedingZero } = textUtils;

const now = new Date();
const years = [1, 2, 3, 4, 5].map((_, index) => {
  const value = now.getFullYear() + index;
  return { label: String(value), value };
});
const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((month) => ({
  label: String(month),
  value: month,
}));

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export default function useFormLogic({ setDate }) {
  const dayMonthYear = useDayMonthYear();
  const { day, month, year } = dayMonthYear;

  const days = React.useMemo(() => {
    const result = [];
    for (let i = 1; i <= dayMonthYear.daysInMonth; i++) {
      result.push({ label: String(i), value: i });
    }
    return result;
  }, [dayMonthYear.daysInMonth]);

  // update date on change
  React.useEffect(() => {
    if (day && month && year) {
      const d = addPrecedingZero(day);
      const m = monthNames[month - 1];
      const h = NamingUtils.isDstObserved(new Date(year, month - 1, day, 2)) ? '20' : '21';
      setDate(new Date(`${m} ${d} ${year} ${h}:00:00 GMT+0000`));
    } else {
      setDate('');
    }
  }, [day, month, setDate, year]);



  const error = React.useMemo(() => {
    if (day && month && year)
      return (
        new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()) >
        new Date(year, month - 1, day)
      );
    return false;
  }, [day, month, year]);

  return { years, months, days, dayMonthYear, error };
}
